// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6084 ? "4e6af11a" : chunkId) + "." + {"1062":"76862af44d0284c6","6084":"3a268aa48b454c84"}[chunkId] + ".js";
};